// extracted by mini-css-extract-plugin
export default {"backLink":"BackLink_backLink__SPAr9"};